// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityCardPage-AuditBanner-AuditBanner-module__box--uUSRm {
  background-color: #fff5d4;
  padding: 9px 24px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.src-pages-EntityCardPage-AuditBanner-AuditBanner-module__info--pnlQR {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityCardPage/AuditBanner/AuditBanner.module.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;AAEA;EACE,OAAA;AAAF","sourcesContent":[".box {\n  background-color: #fff5d4;\n  padding: 9px 24px;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n}\n\n.info {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-pages-EntityCardPage-AuditBanner-AuditBanner-module__box--uUSRm`,
	"info": `src-pages-EntityCardPage-AuditBanner-AuditBanner-module__info--pnlQR`
};
export default ___CSS_LOADER_EXPORT___;
